import React from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDropdownDelay } from '../../hooks/useDropdownDelay';

const ProfileDropdown = ({username, isAdmin}) => {

  const { isOpen, toggle, handleMouseEnter, handleMouseLeave } = useDropdownDelay();
  
  return (
    <Dropdown
      nav
      inNavbar
      isOpen={isOpen}
      toggle={toggle}
      onMouseOver={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <DropdownToggle nav className="pr-0">
        <FontAwesomeIcon icon="user-circle" className="fs-2" />
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-card">
        <div className="bg-white rounded-soft py-2">
          {isAdmin &&
            <div>
              <DropdownItem tag={Link} to="/dashboard">
                <FontAwesomeIcon icon="users-cog" className="mr-1" />
                <span>Manage my events</span>
              </DropdownItem>
              <DropdownItem divider />
            </div>
          }
          <DropdownItem tag={Link} to="/auth/logout">
            <strong>Logout</strong> {username}
          </DropdownItem>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

ProfileDropdown.protoTypes = {
  isAdmin: PropTypes.bool
};

ProfileDropdown.defaultProps = {
  isAdmin: false
};

export default ProfileDropdown;
